const shareButton = document.querySelector(".copy-link-button");
if (shareButton != null) {
  shareButton.addEventListener("click", function () {
    const linkToCopy = document
      .getElementById("linkToCopy")
      .getAttribute("href");
    const tempInput = document.createElement("input");
    tempInput.setAttribute("value", linkToCopy);
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    const copyMessage = document.getElementById("copiedLink");
    copyMessage.style.display = "block";
    // Hide the message after a few seconds
    setTimeout(function () {
      copyMessage.style.display = "none";
    }, 1000);
  });
}
